import React, { useState } from "react";
import Logo from "../../../assets/img/logo.png";
import EyeBlock from "../../../assets/img/eye_block.svg";
import EyeOpen from "../../../assets/img/eye_open.svg";
import { Success, SuccessWithButton } from "../../../components/Alert";
import api from "../../../config/api";

function SuccessPassword(props) {
  return (
    <>
      <div className="container-fluid mb-5 mb-lg-0  h-100">
        <div className="row h-100">
          <div className=" h-100 col-lg-12 d-flex justify-content-center align-items-center ">
            <div className="row m-0">
              <div className="d-flex justify-content-center align-items-center mb-5">
                <img alt="" src={Logo} />
              </div>
              <h1 className="title mb-3 text-center fz-34 ff-univanova-300">
                Senha alterada com sucesso!
                <br />
                <span className="ff-univanova-bold">retorne ao app ;)</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SuccessPassword;
